// extracted by mini-css-extract-plugin
module.exports = {"otherTributes":"index-module--other-tributes--oolUN","articleListContainer":"index-module--article-list-container--28SIV"};